import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { get } from 'lodash';

import './ActorItem.css';
import DefaultImage from './Default-Actor-Image.png';

const ActorItem = props => {
  const { item, index, disableClick } = props;

  const rankClassName = classnames('actor-item__rank', {
    'actor-item__rank--active': index === 0
  });

  const score = get(item, 'score', 0);

  const defaultImageFunc = e => {
    e.target.onerror = null;
    e.target.src = DefaultImage;
    e.target.srcSet = DefaultImage;
  };

  const formattedScore = score.includes('%')
    ? numeral(score).format('0%')
    : numeral(score).format('0,0');

  if (disableClick) {
    return (
      <>
        <div className="actor-item__image-wrapper">
          <p className={rankClassName}>{index + 1}</p>
          <img
            className="actor-item__image"
            src={item.image || DefaultImage}
            onError={defaultImageFunc}
            alt=" "
          />
          <p className="actor-item__score">{formattedScore}</p>
          {get(item, 'total', false) ? (
            <p className="actor-item__total">{item.total}</p>
          ) : null}
        </div>

        <p className="actor-item__name">{item.character}</p>

        <p className="actor-item__name actor-item__name--character">
          {item.name}
        </p>
      </>
    );
  }

  return (
    <>
      <Link to={`/actor/${item.id}`}>
        <div className="actor-item__image-wrapper">
          <p className={rankClassName}>{index + 1}</p>
          <img
            className="actor-item__image"
            src={item.image || DefaultImage}
            onError={defaultImageFunc}
            alt=" "
          />
          <p className="actor-item__score">{formattedScore}</p>
          {get(item, 'total', false) ? (
            <p className="actor-item__total">{item.total}</p>
          ) : null}
        </div>
      </Link>

      <p className="actor-item__name">{item.character}</p>

      <Link to={`/actor/${item.id}`}>
        <p className="actor-item__name actor-item__name--character">
          {item.name}
        </p>
      </Link>
    </>
  );
};

ActorItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired, // for URL
    score: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
    character: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired,
  disableClick: PropTypes.bool
};

ActorItem.defaultProps = {
  disableClick: false
};

export default ActorItem;
